import { render } from "./QbReports.vue?vue&type=template&id=12d81497&scoped=true"
import script from "./QbReports.vue?vue&type=script&lang=js"
export * from "./QbReports.vue?vue&type=script&lang=js"

import "./QbReports.vue?vue&type=style&index=0&id=12d81497&scoped=true&lang=css"

import exportComponent from "/var/www/dev.newtoncommoditiesscripts.com/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12d81497"]])

export default __exports__